import { Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonRow, IonText } from '@ionic/angular/standalone';
import { PuzzleWinDialogInjectableInterface } from '../../shared-module/puzzle-win-dialog/puzzle-win-dialog-injectable.interface';
import { Subscription } from 'rxjs';
import { Store } from '@ngxs/store';
import { map } from 'rxjs/operators';
import { QuizGameState } from '../store/quiz-game.state';
import { PuzzleTimeRecordState } from '../../store/puzzle-time-record.state';
import { QuizPuzzleConfig } from '../interfaces/QuizPuzzleConfig';
import { QuizGameStateModel } from '../store/quiz-game-state.model';
import { PuzzleFrameworkService } from '../../puzzle-framework-module/puzzle-framework.service';
import { PuzzleWinDialogService } from '../../shared-module/puzzle-win-dialog/puzzle-win-dialog.service';
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-quiz-win-screen',
  templateUrl: './quiz-win-screen.component.html',
  styleUrls: ['./quiz-win-screen.component.scss'],
  standalone: true,
  imports: [CommonModule, IonRow, IonText, TranslateModule],
})
export class QuizWinScreenComponent implements PuzzleWinDialogInjectableInterface, OnDestroy {
  data: any;

  private subscriptions: Subscription[] = [];
  public timeString: string;
  public totalQuestions: number;
  public correctAnswers: number;
  public percentCorrect: number;
  public translationKey: string;

  constructor(
    private store: Store,
    private framework: PuzzleFrameworkService,
    private winScreenService: PuzzleWinDialogService,
    private translateService: TranslateService
  ) {
    this.translationKey = this.framework.getTranslationKey();
    this.translateService
      .get(this.translationKey + '.win_dialog.title')
      .toPromise()
      .then((title) => {
        this.winScreenService.setTitle(title);
      });
  }

  setData(data: any): void {
    this.data = data;
    const quizConfig = data.quizConfig as QuizPuzzleConfig;
    this.subscriptions.push(
      this.store
        .select((state) => state.puzzleID)
        .subscribe((puzzleID) => {
          this.subscriptions.push(
            this.store.select(QuizGameState.getByID(puzzleID)).subscribe((quizGame: QuizGameStateModel) => {
              if (!quizGame) {
                return;
              }
              this.totalQuestions = quizGame.userInput.length;

              this.correctAnswers = quizGame.userInput.filter(
                (round, index) => round === quizConfig.questions[index].solution
              ).length;

              this.percentCorrect = Math.floor((this.correctAnswers / this.totalQuestions) * 100);
            })
          );
          this.subscriptions.push(
            this.store
              .select(PuzzleTimeRecordState.getTimeRecordByID)
              .pipe(map((filterFn) => filterFn(puzzleID)))
              .subscribe((time) => {
                this.timeString = time ? time.timeRecord.timeString : '';
              })
          );
        })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.map((sub) => sub.unsubscribe());
    this.subscriptions = [];
  }
}
